import React, { useState } from 'react';
import Icon from '../../../components/AppIcon';

const ResidencyBenefits = () => {
  const [propertyValue, setPropertyValue] = useState('');

  const tiers = [
    {
      name: 'Standard Investor Visa',
      minValue: 750000,
      maxValue: 1999999,
      duration: '2 Years',
      color: '#00D4FF',
      benefits: [
        'UAE residence visa (renewable)',
        'Sponsor spouse and children',
        'UAE bank account access',
        'UAE driving license eligibility',
        'Access to UAE healthcare',
        'Multiple entry/exit',
      ]
    },
    {
      name: 'Golden Visa',
      minValue: 2000000,
      maxValue: Infinity,
      duration: '10 Years',
      color: '#FFD700',
      benefits: [
        '10-year renewable residency',
        'No UAE sponsor required',
        'Sponsor family members',
        'Sponsor domestic workers',
        'Business setup in UAE',
        'Premium healthcare access',
        'Priority government services',
        'UAE passport pathway (long-term)',
      ]
    },
  ];

  const value = parseFloat((propertyValue || '')?.replace(/,/g, ''));
  const activeTier = !isNaN(value) && value > 0 ? tiers?.find(t => value >= t?.minValue && value <= t?.maxValue) : null;

  return (
    <div className="rounded-2xl p-6 md:p-8" style={{ background: 'rgba(10, 22, 40, 0.9)', border: '1px solid rgba(0, 212, 255, 0.2)' }}>
      <div className="flex items-center gap-3 mb-6">
        <div className="w-10 h-10 rounded-xl flex items-center justify-center" style={{ background: 'rgba(0, 212, 255, 0.1)', border: '1px solid rgba(0, 212, 255, 0.3)' }}>
          <Icon name="Award" size={20} color="#00D4FF" />
        </div>
        <div>
          <h3 className="text-lg font-bold" style={{ color: '#E8F4FF' }}>Residency Benefits Calculator</h3>
          <p className="text-sm" style={{ color: '#6B9EC4' }}>Discover your residency entitlements based on investment value</p>
        </div>
      </div>
      <div className="mb-6">
        <label className="block text-sm font-medium mb-2" style={{ color: '#6B9EC4' }}>Property Investment Value (AED)</label>
        <input
          type="text"
          value={propertyValue}
          onChange={e => setPropertyValue(e?.target?.value)}
          placeholder="e.g. 2,000,000"
          className="w-full px-4 py-3 rounded-xl text-sm outline-none"
          style={{ background: 'rgba(0, 212, 255, 0.05)', border: '1px solid rgba(0, 212, 255, 0.2)', color: '#E8F4FF' }}
        />
      </div>
      <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
        {tiers?.map((tier, idx) => {
          const isActive = activeTier?.name === tier?.name;
          const isEligible = !isNaN(value) && value >= tier?.minValue;
          return (
            <div
              key={idx}
              className="p-5 rounded-xl transition-all duration-300"
              style={isActive ? { background: `rgba(${tier?.color === '#FFD700' ? '255, 215, 0' : '0, 212, 255'}, 0.1)`, border: `2px solid ${tier?.color}`, boxShadow: `0 0 20px ${tier?.color}30` } : { background: 'rgba(0, 212, 255, 0.04)', border: '1px solid rgba(0, 212, 255, 0.15)' }}
            >
              <div className="flex items-center justify-between mb-3">
                <div>
                  <h4 className="font-bold text-sm" style={{ color: isActive ? tier?.color : '#E8F4FF' }}>{tier?.name}</h4>
                  <div className="text-xs" style={{ color: '#6B9EC4' }}>Min AED {tier?.minValue?.toLocaleString()}</div>
                </div>
                <div className="text-right">
                  <div className="font-bold" style={{ color: tier?.color }}>{tier?.duration}</div>
                  {isEligible && <div className="text-xs" style={{ color: '#00FF88' }}>✓ Eligible</div>}
                </div>
              </div>
              <div className="space-y-1.5">
                {tier?.benefits?.map((b, i) => (
                  <div key={i} className="flex items-center gap-2">
                    <Icon name="Check" size={12} color={isActive ? tier?.color : '#4A7A9B'} />
                    <span className="text-xs" style={{ color: isActive ? '#6B9EC4' : '#4A7A9B' }}>{b}</span>
                  </div>
                ))}
              </div>
            </div>
          );
        })}
      </div>
      {!activeTier && !isNaN(value) && value > 0 && value < 750000 && (
        <div className="mt-4 p-4 rounded-xl" style={{ background: 'rgba(255, 100, 100, 0.06)', border: '1px solid rgba(255, 100, 100, 0.2)' }}>
          <div className="flex items-center gap-2">
            <Icon name="Info" size={16} color="#FF6464" />
            <span className="text-sm" style={{ color: '#FF6464' }}>Investment below AED 750,000 — not eligible for property investor visa</span>
          </div>
        </div>
      )}
    </div>
  );
};

export default ResidencyBenefits;